export const DESTINATION_MENU = 'MENU';
export const DESTINATION_CATALOG = 'CATALOG';
